import React, { FC } from 'react';

import { DEEP_LINKS_FF_KEY } from './consts';
import OpenInMobileApp from './OpenInMobileApp';
import useFeatureFlagOnce from '../../hooks/useFeatureFlagOnce';
import useOpenInMobileApp from '../../hooks/useOpenInMobileApp';
import FullPageProgressRing from '../FullPageProgressRing';

type OpenInMobileAppConditionalContainerProps = {
  children: React.ReactNode;
};

const OpenInMobileAppConditionalContainer: FC<
  OpenInMobileAppConditionalContainerProps
> = ({ children }) => {
  const { value: showOpenInAppFF, loading: loadingShowOpenInAppFF } =
    useFeatureFlagOnce(DEEP_LINKS_FF_KEY, false);
  const { showOpenInMobileApp, continueInWeb, continueInApp } =
    useOpenInMobileApp();

  if (loadingShowOpenInAppFF) {
    return <FullPageProgressRing />;
  }

  const showOpenInAppEnabled = showOpenInAppFF && !loadingShowOpenInAppFF;
  if (showOpenInAppEnabled && showOpenInMobileApp) {
    return (
      <OpenInMobileApp
        onContinueInApp={continueInApp}
        onContinueInWeb={continueInWeb}
      />
    );
  }

  // we want to render children only if deep links are disabled or if deep links are enabled and the user chose to continue in web
  return <>{children}</>;
};

export default OpenInMobileAppConditionalContainer;
